"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _sum2 = _interopRequireDefault(require("lodash/sum"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * For each item in the list, sum all the values and show sum/total
 * 
 * "renderAs": {
        "type": "SumTotalList",
        "class": "html",
        "settings": {
            "values": [
                {
                    "valuePath": "traumaPre.devTagLists.TraumaExperiencesChecklistPre",
                    "prefix": "",
                    "suffix": "",
                    "showPossibleTotal": true
                },
                {
                    "valuePath": "traumaPost.devTagLists.TraumaExperiencesChecklistEnd",
                    "prefix": "",
                    "suffix": "",
                    "showPossibleTotal": false
                },
                {
                    "valuePath": "cpssPre.devTagLists.PTSDScale",
                    "prefix": "",
                    "suffix": "",
                    "showPossibleTotal": false
                },
                {
                    "valuePath": "cpssPost.devTagLists.PTSDScale",
                    "prefix": "",
                    "suffix": "",
                    "showPossibleTotal": false,
                    "threshold": 14
                },
            ],
            "scale": [
                {
                    "min": 7,
                    "max": 10,
                    "colorClass": "veryHigh"
                },
                {
                    "min": 5,
                    "max": 6,
                    "colorClass": "high"
                },
                {
                    "min": 4,
                    "max": 4,
                    "colorClass": "mid"
                },
                {
                    "min": 0,
                    "max": 3,
                    "colorClass": "average"
                }
            ]
        }
    }
 *
 *  Input: 
 *    traumaPre: {devTagLists: {,…}, __typename: "MetricsResponseSet"}
 *       devTagLists: {,…}
 *          TraumaExperiencesChecklistPre: ["1", "0", "0", "1", "1", "0", "0", "1", "1", "1", "1", "0", "0", "0", "1", "0", "0"]
 *  "cpssPre": {
        "devTagLists": {
          "PTSDScale": [ "0", "1", "2", "3", "2", "1", "0", "1", "2", "3", "3", "2", "1", "0", "1", "2", "3"]
    }
  },
 *  Output:
 *     8/17
 *     10/17
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: _style["default"].container
    }, settings.values.map(function (item, index) {
      var sum = row[item.valuePath] !== null && row[item.valuePath] !== 'undefined' && !(0, _isNil2["default"])(row[item.valuePath]) ? (0, _sum2["default"])(row[item.valuePath].map(Number)) : 0;
      var colorValue = '';
      if (settings.scale !== 'undefined' && !(0, _isNil2["default"])(settings.scale)) {
        for (var i = 0; i < settings.scale.length; i++) {
          if (sum >= settings.scale[i].min && sum <= settings.scale[i].max) {
            colorValue = settings.scale[i].colorClass;
            break;
          }
        }
      }

      // check if any manipulation is needed
      if (item.showPercentage) {
        if (item.showPercentage.divisorOrCount === 'divisor') {
          sum = Math.round(sum / item.showPercentage.divisor * 100);
        } else {
          sum = Math.round(sum / row[item.valuePath].length * 100);
        }
      }
      return sum !== null && sum !== 0 && /*#__PURE__*/_react["default"].createElement("p", {
        key: index,
        className: _style["default"][colorValue]
      }, item.prefix, sum, item.showPossibleTotal ? "/".concat(row[item.valuePath].length) : '', item.suffix);
    }));
  };
};